import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';
import { SurnameDoctor } from '../../models/OutgoingCalls/Doctors';

export interface SurnameDoctorState {
  doctors: SurnameDoctor[];
  status: Status;
}

const initialState: SurnameDoctorState = {
  doctors: [],
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getSurnameDoctor = createAsyncThunk(
  'surnameDoctor/getSurnameDoctor',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<SurnameDoctor[]>('doctor');
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else
        return rejectWithValue('Не удалось получить список специализаций!');
    }
  },
);

export const surnameDoctorSlice = createSlice({
  name: 'surnameDoctor',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getSurnameDoctor.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getSurnameDoctor.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.doctors = action.payload;
        return state;
      })
      .addCase(getSurnameDoctor.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось получить список специализаций';
      });
  },
});

export default surnameDoctorSlice.reducer;

export const selectSurnameDoctor = (state: RootState) =>
  state.surnameDoctor.doctors;
